// packages block
import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { styled, Typography } from "@material-ui/core";
import { Divider, FormControl, TextField } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormSelect, InputWithLabel } from "../form";
import { TextFieldComponent } from "../form/textFeild";
// constants, theme, utils and api block
import { PrimaryButton } from "../../styles/colors";
import {
  RELIGIONS_LIST,
  COUNTRIES,
  GRADES,
  SECTIONS,
  BASE_URL,
  GET_COUNTRIES,
} from "../../util/constants";
import { BLUE_EIGHT } from "../../theme";
import axios from "axios";
import ReactPhoneInput from "react-phone-input-2";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),

      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
      },
    },
  },
}));

export const AddStudentForm = ({
  step,
  studentRegNo,
  parentRegNo,
  firstName,
  lastName,
  grade,
  emiratesId,
  parentPassport,
  dob,
  parentFirstName,
  parentLastName,
  parentGender,
  parentEmiratesId,
  parentCountryId,
  parentReligion,
  area,
  region,
  streetAddress,
  email,
  phoneNumber,
  otherNumber,
  countryId,
  admissionDate,
  section,
  gender,
  handlePersonalData,
  errors,
  setPicValue,
  payeeType,
  handleChangePhone,
  handleChangeParentPhone,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();
  const inputClasses = useStyles();
  const Input = styled("input")({
    display: "none",
  });

  const [countryList, setCountryList] = useState([]);
  const GENDER_LIST = [
    {
      value: "male",
      label: t("text_male"),
    },
    {
      value: "female",
      label: t("text_female"),
    },
    {
      value: "other",
      label: t("text_other"),
    },
  ];

  const PAYEE_TYPE_LIST = [
    {
      value: "STUDENT",
      label: t("text_student"),
    },
    {
      value: "PARENT",
      label: t("text_parent"),
    },
  ];

  useEffect(() => {
    axios.get(`${BASE_URL}/${GET_COUNTRIES}`).then((r) => {
      setCountryList(r.data.countries);
    });
  }, []);

  return (
    <div className={classes.addSchoolForm}>
      {step === 1 ? (
        <div>
          <Typography variant="h6" className={"add-student-form"}>
            {t("text_personal_detail")}
          </Typography>
          <Grid container className={classes.gridRoot} spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                required={true}
                errorMessage={
                  errors.indexOf("firstName") > -1 === true &&
                  t("text_first_name") + " " + t("text_is_required")
                }
                error={errors.indexOf("firstName") > -1}
                value={firstName}
                onChange={handlePersonalData}
                label={t("text_first_name")}
                name={"firstName"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                required={true}
                errorMessage={
                  errors.indexOf("lastName") > -1 === true &&
                  t("text_last_name") + " " + t("text_is_required")
                }
                error={errors.indexOf("lastName") > -1}
                value={lastName}
                onChange={handlePersonalData}
                label={t("text_last_name")}
                name={"lastName"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <InputWithLabel
                type="date"
                required={true}
                errorMessage={
                  errors.indexOf("dob") > -1 === true &&
                  t("text_date_of_birth") + " " + t("text_is_required")
                }
                error={errors.indexOf("dob") > -1}
                value={dob}
                onChange={handlePersonalData}
                label={`${t("text_date_of_birth")} *`}
                name={"dob"}
              />
            </Grid>

            <Grid item sm={6} xs={12} style={{ paddingRight: "15px" }}>
              <FormSelect
                value={gender}
                onChange={handlePersonalData}
                label={t("text_gender")}
                name={"gender"}
                list={GENDER_LIST}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <FormControl
                className={inputClasses.root}
                variant="outlined"
                fullWidth
              >
                <InputMask
                  mask="999-9999-9999999-9"
                  value={emiratesId}
                  onChange={handlePersonalData("emiratesId")}
                >
                  {(inputProps) => (
                    <TextField
                      {...inputProps}
                      color={BLUE_EIGHT}
                      label={t("text_emirates_id")}
                      type="text"
                      name={"emiratesId"}
                      value={emiratesId}
                      id="text-input"
                      size="small"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </InputMask>
              </FormControl>
            </Grid>

            <Grid item sm={6} xs={12} style={{ paddingRight: "15px" }}>
              <FormSelect
                value={countryId}
                onChange={handlePersonalData}
                label={"Country"}
                name={"countryId"}
                list={COUNTRIES}
                countryList={countryList}
              />
            </Grid>

            <Grid item sm={6} xs={12}></Grid>
          </Grid>

          <div style={{ padding: "20px 0px" }}>
            <Divider />
          </div>

          <Typography variant="h6" className={"add-student-form"}>
            {t("text_parent's_detail")}
          </Typography>
          <Grid container className={classes.gridRoot} spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={parentFirstName}
                onChange={handlePersonalData}
                label={t("text_first_name")}
                name={"parentFirstName"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={parentLastName}
                onChange={handlePersonalData}
                label={t("text_last_name")}
                name={"parentLastName"}
              />
            </Grid>

            <Grid item sm={6} xs={12} style={{ paddingRight: "15px" }}>
              <FormSelect
                value={parentGender}
                onChange={handlePersonalData}
                label={t("text_gender")}
                name={"parentGender"}
                list={GENDER_LIST}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <FormControl
                className={inputClasses.root}
                variant="outlined"
                fullWidth
              >
                <InputMask
                  mask="999-9999-9999999-9"
                  value={parentEmiratesId}
                  onChange={handlePersonalData("parentEmiratesId")}
                >
                  {(inputProps) => (
                    <TextField
                      {...inputProps}
                      color={BLUE_EIGHT}
                      label={t("text_emirates_id")}
                      type="text"
                      value={parentEmiratesId}
                      id="text-input"
                      size="small"
                      name={"parentEmiratesId"}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </InputMask>
              </FormControl>
            </Grid>

            <Grid item sm={6} xs={12} style={{ paddingRight: "15px" }}>
              <FormSelect
                value={parentCountryId}
                onChange={handlePersonalData}
                label={"Country"}
                name={"parentCountryId"}
                list={COUNTRIES}
                countryList={countryList}
              />
            </Grid>

            <Grid item sm={6} xs={12} style={{ paddingRight: "15px" }}>
              <FormSelect
                value={parentReligion}
                onChange={handlePersonalData}
                label={t("text_religion")}
                name={"parentReligion"}
                list={RELIGIONS_LIST}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={parentPassport}
                onChange={handlePersonalData}
                label={t("text_parent_passport_number")}
                name={"parentPassport"}
              />
            </Grid>
          </Grid>

          <div style={{ padding: "20px 0px" }}>
            <Divider />
          </div>

          <Typography variant="h6" className={"add-student-form"}>
            {t("text_address_and_contact_detail")}
          </Typography>
          <Grid container className={classes.gridRoot} spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={area}
                onChange={handlePersonalData}
                label={t("text_area")}
                name={"area"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={region}
                onChange={handlePersonalData}
                label={t("text_region")}
                name={"region"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextFieldComponent
                value={streetAddress}
                onChange={handlePersonalData}
                label={t("text_address")}
                name={"streetAddress"}
              />
            </Grid>

            <Grid
              item
              sm={6}
              xs={12}
              style={{ paddingLeft: "15px", paddingRight: "16px" }}
            >
              <ReactPhoneInput
                containerClass="my-phone-input"
                inputStyle={{
                  marginTop: "6px",
                  width: "100%",
                  borderRadius: "10px",
                }}
                value={phoneNumber}
                name={"phoneNumber"}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                onChange={handleChangePhone}
                country={"ae"}
                specialLabel={`${t("text_phone_number")} *`}
                defaultErrorMessage={
                  t("text_phone_number") + " " + t("text_is_required")
                }
                placeholder={"XXXXXXXXXX"}
              />
              {/*<span*/}
              {/*  style={{ fontSize: "0.65vw", paddingLeft: 10, color: "red" }}*/}
              {/*>*/}
              {/*  {"Phone number is required"}*/}
              {/*</span>*/}
              {/*<TextFieldComponent*/}
              {/*  required={true}*/}
              {/*  errorMessage={*/}
              {/*    errors.indexOf("phoneNumber") > -1 === true &&*/}
              {/*    t("text_phone_number") + " " + t("text_is_required")*/}
              {/*  }*/}
              {/*  error={errors.indexOf("phoneNumber") > -1}*/}
              {/*  type="text"*/}
              {/*  value={phoneNumber}*/}
              {/*  onChange={handlePersonalData}*/}
              {/*  label={t("text_phone_number")}*/}
              {/*  name={"phoneNumber"}*/}
              {/*/>*/}
            </Grid>

            <Grid
              item
              sm={6}
              xs={12}
              style={{ paddingRight: "15px", paddingLeft: "16px" }}
            >
              <ReactPhoneInput
                containerClass="my-phone-input"
                inputStyle={{
                  marginTop: "6px",
                  width: "100%",
                  borderRadius: "10px",
                }}
                value={otherNumber}
                name={"otherNumber"}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                onChange={handleChangeParentPhone}
                country={"ae"}
                specialLabel={t("text_other_number")}
                defaultErrorMessage={
                  t("text_phone_number") + " " + t("text_is_required")
                }
                placeholder={"XXXXXXXXXX"}
              />
              {/*<TextFieldComponent*/}
              {/*  type="text"*/}
              {/*  value={otherNumber}*/}
              {/*  onChange={handlePersonalData}*/}
              {/*  label={t("text_other_number")}*/}
              {/*  name={"otherNumber"}*/}
              {/*/>*/}
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                required={true}
                errorMessage={
                  errors.indexOf("email") > -1 === true &&
                  t("text_email_address") + " " + t("text_is_required")
                }
                error={errors.indexOf("email") > -1}
                value={email}
                onChange={handlePersonalData}
                label={t("text_email_address")}
                name={"email"}
                placeholder="paynest@gmail.com"
              />
            </Grid>
          </Grid>

          <div style={{ padding: "20px 0px" }}>
            <Typography variant="h6" className={"add-student-form"}>
              {t("text_add_scanned_image_of_student's_uae_id_card")}
            </Typography>

            <div
              style={{
                width: "100%",
                border: "1px dashed rgb(240,242,248)",
                padding: 7,
                borderRadius: 5,
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: 15,
                  borderRadius: 5,
                  backgroundColor: "rgb(240,242,248)",
                  color: "black",
                  fontSize: 14,
                  fontWeight: "400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CloudUploadIcon
                  style={{ color: "lightgray", marginRight: 10 }}
                />{" "}
                <Typography variant="body2">
                  {t("text_drag_&_drop")}{" "}
                  <span style={{ color: "gray", paddingLeft: 5 }}>
                    {t("text_your_files_or")}{" "}
                  </span>
                  <span
                    style={{
                      color: PrimaryButton,
                      paddingLeft: 5,
                      paddingTop: 10,
                    }}
                  >
                    <label htmlFor="contained-button-file">
                      <Input
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={(e) => {
                          setPicValue(e.target.files[0]);
                        }}
                      />

                      <span
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {t("text_browse")}
                      </span>
                    </label>
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <Typography variant="h6" className={"add-student-form"}>
            {t("text_grade_details")}
          </Typography>
          <Grid container className={classes.gridRoot} spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={payeeType === "STUDENT" ? studentRegNo : parentRegNo}
                onChange={handlePersonalData}
                required={true}
                error={errors.indexOf("payeeId") > -1}
                errorMessage={
                  errors.indexOf("payeeId") > -1 === true &&
                  t("text_payee_id") + " " + t("text_is_required")
                }
                label={t("text_payee_id")}
                name={payeeType === "STUDENT" ? "studentRegNo" : "parentRegNo"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <InputWithLabel
                type="date"
                required={true}
                errorMessage={
                  errors.indexOf("admissionDate") > -1 === true &&
                  t("text_date_of_admission") + " " + t("text_is_required")
                }
                error={errors.indexOf("admissionDate") > -1}
                value={admissionDate}
                onChange={handlePersonalData}
                label={t("text_date_of_admission")}
                name={"admissionDate"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={grade}
                onChange={handlePersonalData}
                label={t("text_grade")}
                name={"grade"}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldComponent
                value={section}
                onChange={handlePersonalData}
                label={t("text_section")}
                name={"section"}
              />
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};
